const plans = [
  {
    path: "",
    name: "plan-list",
    meta: {
      breadcrumb: "PLANS",
    },
    component: () =>
      import(/* webpackChunkName: "plans" */ "@/pages/Dashboard/Plans/PlansList.vue"),
  },
  {
    path: ":planId",
    name: "plan-detail",
    component: () => import(/* webpackChunkName: "plans" */ "@/pages/Dashboard/Plans/Plan.vue"),
    meta: {
      sidebar: "PLAN",
    },
    redirect: {
      name: "plan-sites",
    },
    props: (route) => ({ planId: Number.parseInt(route.params.planId) }),
    children: [
      {
        path: "sites",
        name: "plan-sites",
        meta: {
          breadcrumb: "PLAN_SITES",
          sidebar: "PLAN",
        },
        component: () =>
          import(/* webpackChunkName: "plans" */ "@/pages/Dashboard/Plans/Plan/Sites.vue"),
      },
      {
        path: "sites/:siteId",
        name: "plan-site-detail",
        component: () =>
          import(/* webpackChunkName: "plans" */ "@/pages/Dashboard/Plans/Plan/Site.vue"),
        redirect: {
          name: "plan-site-access",
        },
        meta: {
          sidebar: "PLAN_SITE",
        },
        props: (route) => ({ siteId: Number.parseInt(route.params.siteId) }),
        children: [
          {
            path: "apm",
            name: "plan-site-apm",
            component: () =>
              import(/* webpackChunkName: "plans" */ "@/pages/Dashboard/Plans/Plan/Site/Apm.vue"),
          },
          {
            path: "performance",
            name: "plan-site-performance",
            meta: {
              breadcrumb: "PLAN_SITE_PERFORMANCE",
            },
            component: () =>
              import(
                /* webpackChunkName: "plans" */ "@/pages/Dashboard/Plans/Plan/Site/Performance.vue"
              ),
          },
          {
            path: "access",
            name: "plan-site-access",
            meta: {
              breadcrumb: "PLAN_SITE_ACCESS",
            },
            component: () =>
              import(
                /* webpackChunkName: "plans" */ "@/pages/Dashboard/Plans/Plan/Site/Access.vue"
              ),
          },
          {
            path: "domain-options",
            name: "plan-site-domain-options",
            meta: {
              breadcrumb: "PLAN_SITE_DOMAIN_OPTIONS",
            },
            component: () =>
              import(
                /* webpackChunkName: "plans" */ "@/pages/Dashboard/Plans/Plan/Site/DomainOptions.vue"
              ),
          },
          {
            path: "environment",
            name: "plan-site-environment",
            meta: {
              breadcrumb: "PLAN_SITE_ENVIRONMENT",
            },
            component: () =>
              import(
                /* webpackChunkName: "plans" */ "@/pages/Dashboard/Plans/Plan/Site/Environment.vue"
              ),
          },
          {
            path: "ssl",
            name: "plan-site-ssl",
            meta: {
              breadcrumb: "PLAN_SITE_SSL",
            },
            component: () =>
              import(/* webpackChunkName: "plans" */ "@/pages/Dashboard/Plans/Plan/Site/Ssl.vue"),
          },
          {
            path: "logs",
            name: "plan-site-logs",
            meta: {
              breadcrumb: "PLAN_SITE_LOGS",
            },
            component: () =>
              import(/* webpackChunkName: "plans" */ "@/pages/Dashboard/Plans/Plan/Site/Logs.vue"),
          },
          {
            path: "tasks",
            name: "plan-site-tasks",
            meta: {
              breadcrumb: "PLAN_SITE_TASKS",
            },
            component: () =>
              import(/* webpackChunkName: "plans" */ "@/pages/Dashboard/Plans/Plan/Site/Tasks.vue"),
          },
          {
            path: "db",
            name: "plan-site-db",
            meta: {
              breadcrumb: "PLAN_SITE_DB",
            },
            component: () =>
              import(/* webpackChunkName: "plans" */ "@/pages/Dashboard/Plans/Plan/Site/Db.vue"),
          },
          {
            path: "email",
            name: "plan-site-email",
            meta: {
              breadcrumb: "PLAN_SITE_EMAIL",
            },
            component: () =>
              import(/* webpackChunkName: "plans" */ "@/pages/Dashboard/Plans/Plan/Site/Email.vue"),
          },
          {
            path: "backups",
            name: "plan-site-backups",
            meta: {
              breadcrumb: "PLAN_SITE_BACKUPS",
            },
            component: () =>
              import(
                /* webpackChunkName: "plans" */ "@/pages/Dashboard/Plans/Plan/Site/Backups.vue"
              ),
          },
          {
            path: "visual-compare",
            name: "plan-site-visual-compare",
            meta: {
              breadcrumb: "PLAN_SITE_VISUAL_COMPARE",
            },
            component: () =>
              import(
                /* webpackChunkName: "plans" */ "@/pages/Dashboard/Plans/Plan/Site/VisualCompare.vue"
              ),
          },
          {
            path: "containers",
            name: "plan-site-containers",
            meta: {
              breadcrumb: "PLAN_SITE_CONTAINERS",
            },
            component: () =>
              import(
                /* webpackChunkName: "plans" */ "@/pages/Dashboard/Plans/Plan/Site/Containers.vue"
              ),
          },
          {
            path: "stencils",
            name: "plan-site-stencils",
            meta: {
              breadcrumb: "PLAN_SITE_STENCILS",
            },
            component: () =>
              import(
                /* webpackChunkName: "plans" */ "@/pages/Dashboard/Plans/Plan/Site/Stencils.vue"
              ),
          },
          {
            path: "control-panel",
            name: "plan-site-control-panel",
            meta: {
              breadcrumb: "PLAN_SITE_CONTROL_PANEL",
            },
            component: () =>
              import(
                /* webpackChunkName: "plans" */ "@/pages/Dashboard/Plans/Plan/Site/ControlPanel.vue"
              ),
          },
          {
            path: "dev-environments",
            name: "plan-site-dev-environments",
            meta: {
              breadcrumb: "PLAN_SITE_DEV_ENVIRONMENTS",
            },
            component: () =>
              import(
                /* webpackChunkName: "plans" */ "@/pages/Dashboard/Plans/Plan/Site/DevEnvironments.vue"
              ),
            props: (route) => ({
              siteId: Number.parseInt(route.params.siteId),
            }),
          },
          {
            path: "dev-environments/:devSiteId",
            name: "plan-site-dev-detail",
            redirect: {
              name: "plan-site-dev-performance",
            },
            component: () =>
              import(
                /* webpackChunkName: "plans" */ "@/pages/Dashboard/Plans/Plan/Site/DevEnvironment.vue"
              ),
            props: (route) => ({
              devSiteId: Number.parseInt(route.params.devSiteId),
            }),
            meta: {
              sidebar: "PLAN_SITE_DEV",
            },
            children: [
              {
                path: "performance",
                name: "plan-site-dev-performance",
                meta: {
                  breadcrumb: "PLAN_SITE_DEV_PERFORMANCE",
                },
                component: () =>
                  import(
                    /* webpackChunkName: "plans" */ "@/pages/Dashboard/Plans/Plan/Site/DevEnvironment/Performance.vue"
                  ),
              },
              {
                path: "settings",
                name: "plan-site-dev-settings",
                meta: {
                  breadcrumb: "PLAN_SITE_DEV_SETTINGS",
                },
                component: () =>
                  import(
                    /* webpackChunkName: "plans" */ "@/pages/Dashboard/Plans/Plan/Site/DevEnvironment/Settings.vue"
                  ),
              },
              {
                path: "access",
                name: "plan-site-dev-access",
                meta: {
                  breadcrumb: "PLAN_SITE_DEV_ACCESS",
                },
                component: () =>
                  import(
                    /* webpackChunkName: "plans" */ "@/pages/Dashboard/Plans/Plan/Site/DevEnvironment/Access.vue"
                  ),
              },
              {
                path: "domain-options",
                name: "plan-site-dev-domain-options",
                meta: {
                  breadcrumb: "PLAN_SITE_DEV_DOMAIN_OPTIONS",
                },
                component: () =>
                  import(
                    /* webpackChunkName: "plans" */ "@/pages/Dashboard/Plans/Plan/Site/DevEnvironment/DomainOptions.vue"
                  ),
              },
              {
                path: "environment",
                name: "plan-site-dev-environment",
                meta: {
                  breadcrumb: "PLAN_SITE_DEV_ENVIRONMENT",
                },
                component: () =>
                  import(
                    /* webpackChunkName: "plans" */ "@/pages/Dashboard/Plans/Plan/Site/DevEnvironment/Environment.vue"
                  ),
              },
              {
                path: "ssl",
                name: "plan-site-dev-ssl",
                meta: {
                  breadcrumb: "PLAN_SITE_DEV_SSL",
                },
                component: () =>
                  import(
                    /* webpackChunkName: "plans" */ "@/pages/Dashboard/Plans/Plan/Site/DevEnvironment/Ssl.vue"
                  ),
              },
              {
                path: "logs",
                name: "plan-site-dev-logs",
                meta: {
                  breadcrumb: "PLAN_SITE_DEV_LOGS",
                },
                component: () =>
                  import(
                    /* webpackChunkName: "plans" */ "@/pages/Dashboard/Plans/Plan/Site/DevEnvironment/Logs.vue"
                  ),
              },
              {
                path: "tasks",
                name: "plan-site-dev-tasks",
                meta: {
                  breadcrumb: "PLAN_SITE_DEV_TASKS",
                },
                component: () =>
                  import(
                    /* webpackChunkName: "plans" */ "@/pages/Dashboard/Plans/Plan/Site/DevEnvironment/Tasks.vue"
                  ),
              },
              {
                path: "db",
                name: "plan-site-dev-db",
                meta: {
                  breadcrumb: "PLAN_SITE_DEV_DB",
                },
                component: () =>
                  import(
                    /* webpackChunkName: "plans" */ "@/pages/Dashboard/Plans/Plan/Site/DevEnvironment/Db.vue"
                  ),
              },
              {
                path: "email",
                name: "plan-site-dev-email",
                meta: {
                  breadcrumb: "PLAN_SITE_DEV_EMAIL",
                },
                component: () =>
                  import(
                    /* webpackChunkName: "plans" */ "@/pages/Dashboard/Plans/Plan/Site/DevEnvironment/Email.vue"
                  ),
              },
              {
                path: "backups",
                name: "plan-site-dev-backups",
                meta: {
                  breadcrumb: "PLAN_SITE_DEV_BACKUPS",
                },
                component: () =>
                  import(
                    /* webpackChunkName: "plans" */ "@/pages/Dashboard/Plans/Plan/Site/DevEnvironment/Backups.vue"
                  ),
              },
              {
                path: "visual-compare",
                name: "plan-site-dev-visual-compare",
                meta: {
                  breadcrumb: "PLAN_SITE_DEV_VISUAL_COMPARE",
                },
                component: () =>
                  import(
                    /* webpackChunkName: "plans" */ "@/pages/Dashboard/Plans/Plan/Site/DevEnvironment/VisualCompare.vue"
                  ),
              },
              {
                path: "containers",
                name: "plan-site-dev-containers",
                meta: {
                  breadcrumb: "PLAN_SITE_DEV_CONTAINERS",
                },
                component: () =>
                  import(
                    /* webpackChunkName: "plans" */ "@/pages/Dashboard/Plans/Plan/Site/DevEnvironment/Containers.vue"
                  ),
              },
            ],
          },
        ],
      },
      {
        path: "stencils",
        name: "plan-stencils",
        meta: {
          breadcrumb: "PLAN_STENCILS",
        },
        component: () =>
          import(/* webpackChunkName: "plans" */ "@/pages/Dashboard/Plans/Plan/Stencils.vue"),
      },
      {
        path: "performance",
        name: "plan-performance",
        meta: {
          breadcrumb: "PLAN_PERFORMANCE",
        },
        component: () =>
          import(/* webpackChunkName: "plans" */ "@/pages/Dashboard/Plans/Plan/Performance.vue"),
      },
      {
        path: "architecture",
        name: "plan-architecture",
        meta: {
          breadcrumb: "PLAN_ARCHITECTURE",
        },
        component: () =>
          import(/* webpackChunkName: "plans" */ "@/pages/Dashboard/Plans/Plan/Architecture.vue"),
      },
      {
        path: "access",
        name: "plan-access",
        meta: {
          breadcrumb: "PLAN_ACCESS",
        },
        component: () =>
          import(/* webpackChunkName: "plans" */ "@/pages/Dashboard/Plans/Plan/Access.vue"),
      },
      {
        path: "environment",
        name: "plan-environment",
        meta: {
          breadcrumb: "PLAN_ENVIRONMENT",
        },
        component: () =>
          import(/* webpackChunkName: "plans" */ "@/pages/Dashboard/Plans/Plan/Environment.vue"),
      },
      {
        path: "settings",
        name: "plan-settings",
        meta: {
          breadcrumb: "PLAN_SETTINGS",
        },
        component: () =>
          import(/* webpackChunkName: "plans" */ "@/pages/Dashboard/Plans/Plan/Settings.vue"),
      },
      {
        path: "db",
        name: "plan-db",
        meta: {
          breadcrumb: "PLAN_DB",
        },
        component: () =>
          import(/* webpackChunkName: "plans" */ "@/pages/Dashboard/Plans/Plan/Db.vue"),
      },
      {
        path: "containers",
        name: "plan-containers",
        meta: {
          breadcrumb: "PLAN_CONTAINERS",
        },
        component: () =>
          import(/* webpackChunkName: "plans" */ "@/pages/Dashboard/Plans/Plan/Containers.vue"),
      },
      {
        path: "control-panel",
        name: "plan-control-panel",
        meta: {
          breadcrumb: "PLAN_CONTROL_PANEL",
        },
        component: () =>
          import(/* webpackChunkName: "plans" */ "@/pages/Dashboard/Plans/Plan/ControlPanel.vue"),
      },
      {
        path: "tasks",
        name: "plan-tasks",
        meta: {
          breadcrumb: "PLAN_TASKS",
        },
        component: () =>
          import(/* webpackChunkName: "plans" */ "@/pages/Dashboard/Plans/Plan/Tasks.vue"),
      },
      {
        path: "email",
        name: "plan-email",
        meta: {
          breadcrumb: "PLAN_EMAIL",
        },
        component: () =>
          import(/* webpackChunkName: "plans" */ "@/pages/Dashboard/Plans/Plan/Email.vue"),
      },
      {
        path: "safe-harbor",
        name: "plan-safe-harbor",
        meta: {
          breadcrumb: "PLAN_SAFE_HARBOR",
          sidebar: "PLAN_SAFE_HARBOR",
        },
        component: () =>
          import(/* webpackChunkName: "plans" */ "@/pages/Dashboard/Plans/Plan/SafeHarbor.vue"),
        redirect: {
          name: "plan-safe-harbor-malware-scans",
        },
        children: [
          {
            path: "malware-scans",
            name: "plan-safe-harbor-malware-scans",
            meta: {
              breadcrumb: "PLAN_SAFE_HARBOR_MALWARE_SCANS",
            },
            component: () =>
              import(
                /* webpackChunkName: "plans" */ "@/pages/Dashboard/Plans/Plan/SafeHarbor/MalwareScans.vue"
              ),
          },
          {
            path: "protection",
            name: "plan-safe-harbor-threat-protection",
            meta: {
              breadcrumb: "PLAN_SAFE_HARBOR_THREAT_PROTECTION",
            },
            component: () =>
              import(
                /* webpackChunkName: "plans" */ "@/pages/Dashboard/Plans/Plan/SafeHarbor/ThreatProtection.vue"
              ),
          },
          {
            path: "staging-environments",
            name: "plan-safe-harbor-staging-environments",
            meta: {
              breadcrumb: "PLAN_SAFE_HARBOR_STAGING_ENVIRONMENTS",
            },
            component: () =>
              import(
                /* webpackChunkName: "plans" */ "@/pages/Dashboard/Plans/Plan/SafeHarbor/StagingEnvironments.vue"
              ),
          },
          {
            path: "patches",
            name: "plan-safe-harbor-magento-patches",
            meta: {
              breadcrumb: "PLAN_SAFE_HARBOR_MAGENTO_PATCHES",
            },
            component: () =>
              import(
                /* webpackChunkName: "plans" */ "@/pages/Dashboard/Plans/Plan/SafeHarbor/MagentoPatches.vue"
              ),
          },
        ],
      },
    ],
  },
  {
    path: ":planId/safe-harbor/staging-environments/:stagingEnvironmentId",
    name: "plan-safe-harbor-staging-environment",
    meta: {
      breadcrumb: "PLAN_SAFE_HARBOR_STAGING_ENVIRONMENT",
      sidebar: "PLAN_SAFE_HARBOR_STAGING_ENVIRONMENT",
    },
    component: () =>
      import(
        /* webpackChunkName: "plans" */ "@/pages/Dashboard/Plans/Plan/SafeHarbor/StagingEnvironment"
      ),
    props: (route) => ({
      serviceId: Number(route.params.planId),
      stagingEnvironmentId: Number(route.params.stagingEnvironmentId),
    }),
    redirect: {
      name: "plan-safe-harbor-staging-environment-performance",
    },
    children: [
      {
        path: "performance",
        name: "plan-safe-harbor-staging-environment-performance",
        meta: {
          breadcrumb: "PLAN_SAFE_HARBOR_STAGING_ENVIRONMENT_PERFORMANCE",
        },
        component: () =>
          import(
            /* webpackChunkName: "plans" */ "@/pages/Dashboard/SharedHosting/SafeHarbor/StagingEnvironment/Performance"
          ),
      },
      {
        path: "access",
        name: "plan-safe-harbor-staging-environment-access",
        meta: {
          breadcrumb: "PLAN_SAFE_HARBOR_STAGING_ENVIRONMENT_ACCESS",
        },
        component: () =>
          import(
            /* webpackChunkName: "plans" */ "@/pages/Dashboard/SharedHosting/SafeHarbor/StagingEnvironment/Access"
          ),
      },
      {
        path: "domain-options",
        name: "plan-safe-harbor-staging-environment-domain-options",
        meta: {
          breadcrumb: "PLAN_SAFE_HARBOR_STAGING_ENVIRONMENT_DOMAIN_OPTIONS",
        },
        component: () =>
          import(
            /* webpackChunkName: "plans" */ "@/pages/Dashboard/SharedHosting/SafeHarbor/StagingEnvironment/DomainOptions"
          ),
      },
      {
        path: "settings",
        name: "plan-safe-harbor-staging-environment-settings",
        meta: {
          breadcrumb: "PLAN_SAFE_HARBOR_STAGING_ENVIRONMENT_SETTINGS",
        },
        component: () =>
          import(
            /* webpackChunkName: "plans" */ "@/pages/Dashboard/SharedHosting/SafeHarbor/StagingEnvironment/Settings"
          ),
      },
      {
        path: "environment",
        name: "plan-safe-harbor-staging-environment-environment",
        meta: {
          breadcrumb: "PLAN_SAFE_HARBOR_STAGING_ENVIRONMENT_ENVIRONMENT",
        },
        component: () =>
          import(
            /* webpackChunkName: "plans" */ "@/pages/Dashboard/SharedHosting/SafeHarbor/StagingEnvironment/Environment"
          ),
      },
      {
        path: "ssl",
        name: "plan-safe-harbor-staging-environment-ssl",
        meta: {
          breadcrumb: "PLAN_SAFE_HARBOR_STAGING_ENVIRONMENT_SSL",
        },
        component: () =>
          import(
            /* webpackChunkName: "plans" */ "@/pages/Dashboard/SharedHosting/SafeHarbor/StagingEnvironment/Ssl"
          ),
      },
      {
        path: "Logs",
        name: "plan-safe-harbor-staging-environment-logs",
        meta: {
          breadcrumb: "PLAN_SAFE_HARBOR_STAGING_ENVIRONMENT_LOGS",
        },
        component: () =>
          import(
            /* webpackChunkName: "plans" */ "@/pages/Dashboard/SharedHosting/SafeHarbor/StagingEnvironment/Logs"
          ),
      },
      {
        path: "db",
        name: "plan-safe-harbor-staging-environment-db",
        meta: {
          breadcrumb: "PLAN_SAFE_HARBOR_STAGING_ENVIRONMENT_DB",
        },
        component: () =>
          import(
            /* webpackChunkName: "plans" */ "@/pages/Dashboard/SharedHosting/SafeHarbor/StagingEnvironment/Db"
          ),
      },
      {
        path: "tasks",
        name: "plan-safe-harbor-staging-environment-tasks",
        meta: {
          breadcrumb: "PLAN_SAFE_HARBOR_STAGING_ENVIRONMENT_TASKS",
        },
        component: () =>
          import(
            /* webpackChunkName: "plans" */ "@/pages/Dashboard/SharedHosting/SafeHarbor/StagingEnvironment/Tasks"
          ),
      },
      {
        path: "email",
        name: "plan-safe-harbor-staging-environment-email",
        meta: {
          breadcrumb: "PLAN_SAFE_HARBOR_STAGING_ENVIRONMENT_EMAIL",
        },
        component: () =>
          import(
            /* webpackChunkName: "plans" */ "@/pages/Dashboard/SharedHosting/SafeHarbor/StagingEnvironment/Email"
          ),
      },
      {
        path: "backups",
        name: "plan-safe-harbor-staging-environment-backups",
        meta: {
          breadcrumb: "PLAN_SAFE_HARBOR_STAGING_ENVIRONMENT_BACKUPS",
        },
        component: () =>
          import(
            /* webpackChunkName: "plans" */ "@/pages/Dashboard/SharedHosting/SafeHarbor/StagingEnvironment/Backups"
          ),
      },
      {
        path: "containers",
        name: "plan-safe-harbor-staging-environment-containers",
        meta: {
          breadcrumb: "PLAN_SAFE_HARBOR_STAGING_ENVIRONMENT_CONTAINERS",
        },
        component: () =>
          import(
            /* webpackChunkName: "plans" */ "@/pages/Dashboard/SharedHosting/SafeHarbor/StagingEnvironment/Containers"
          ),
      },
      {
        path: "control-panel",
        name: "plan-safe-harbor-staging-environment-control-panel",
        meta: {
          breadcrumb: "PLAN_SAFE_HARBOR_STAGING_ENVIRONMENT_CONTROL_PANEL",
        },
        component: () =>
          import(
            /* webpackChunkName: "plans" */ "@/pages/Dashboard/SharedHosting/SafeHarbor/StagingEnvironment/ControlPanel"
          ),
      },
    ],
  },
];

export default plans;
